/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  rotaDayListAPI,
  showCarerEstimatehrsAPI,
  showClientEstimatehrsAPI,
  totalestimetedhrsAPI,
  trainingListAPI,
} from "./RotaTableData";
import { RotaOptions } from "../../../utils";
import RotaMatrix from "./RotaMatrix";
import { LoadingComponent } from "../../../components/Component";
import { getDates } from "../../../utils/Functions";

export const RotaType = {
  hospital: "hospital",
  carer: "carer",
};

const RotaList = ({
  type,
  selectedId,
  carerId,
  clientId,
  startDate,
  endDate,
  status,
  branchId,
  gradeId,
  agencyId,
  shiftType,
  isSwitchOn,
}) => {
  const [rotaList, setRotaList] = useState([]);
  const [totalRotaHours, setTotalRotaHours] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [clientdata, setClientdata] = useState({});

  const datesBetween = getDates(startDate, endDate);

  const fetchData = async () => {
    try {
      if (currentPage !== 1) {
        setCurrentPage(1);
        return;
      }

      const [rotaData, trainingData] = await Promise.all([loadRotaAPI(), loadTrainingAPI()]);

      const combinedArray = [...rotaData, ...trainingData];

      if (type === RotaType.carer) {
        setRotaList(combinedArray);
      } else if (type === RotaType.hospital) {
        setRotaList(rotaData);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  useEffect(() => {
    gettotalEstimetedhours();
  }, [startDate, endDate, carerId, clientId, status, agencyId, branchId, gradeId, shiftType]);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, startDate, endDate, carerId, clientId, shiftType, branchId, gradeId, agencyId]);

  function loadTrainingAPI() {
    return new Promise((resolve, reject) => {
      let params = {
        startDate,
        endDate,
        status: status === RotaOptions.open ? "ACTIVE" : status,
        carerId: carerId ?? 0,
      };

      trainingListAPI(params, (data, error) => {
        if (error === null) {
          resolve(data.list);
        } else {
          reject(error);
        }
      });
    });
  }

  function loadRotaAPI() {
    return new Promise((resolve, reject) => {
      if (!type && (!startDate || !endDate)) return resolve([]);
      if (loading) return resolve([]);

      let params = {
        startDate,
        endDate,
        branchId: branchId || null,
        gradeId: gradeId || null,
        shiftType: shiftType?.value === "ANY" ? "" : shiftType?.value || null,
        status: status === RotaOptions.open ? "ACTIVE" : status,
        carerId: carerId ?? 0,
        clientId: clientId ?? 0,
        agencyId: agencyId ?? 0,
      };

      rotaDayListAPI(params, (data, error) => {
        if (error === null) {
          resolve(data.list);
        } else {
          reject(error);
        }
      });
    });
  }

  // function loadRotaAPI() {
  //   if (!type && (!startDate || !endDate)) return;
  //   if (loading) return;

  //   let params = {
  //     startDate: startDate,
  //     endDate: endDate,
  //     branchId: branchId ? branchId : null,
  //     gradeId: gradeId ? gradeId : null,
  //     shiftType: shiftType?.value === "ANY" ? "" : shiftType ? shiftType.value : null,
  //     status: status === RotaOptions.open ? "ACTIVE" : status,
  //     carerId: carerId ?? 0,
  //     clientId: clientId ?? 0,
  //     agencyId: agencyId ?? 0,
  //   };
  //   // setLoading(true);
  //   rotaDayListAPI(params, (data, error) => {
  //     if (error === null) {
  //       if (currentPage === 1) {
  //         setRotaList(data.list);
  //       }
  //     }
  //     // setLoading(false);
  //   });
  // }
  function gettotalEstimetedhours() {
    let params = {
      startDate: startDate,
      endDate: endDate,
      carerId: carerId ?? 0,
      clientId: clientId ?? 0,
      status: status === RotaOptions.open ? "ACTIVE" : status,
      agencyId: agencyId ?? 0,
      branchId: branchId ?? 0,
      gradeId: gradeId ?? 0,
      shiftType: shiftType?.value === "ANY" ? "" : shiftType?.value || null,
    };
    totalestimetedhrsAPI(params, (data, error) => {
      if (error === null) {
        setTotalRotaHours(data);
      }
      // setLoading(false);
    });
  }
  function showclientEstimatehoursList() {
    if (!carerId) return;
    let params = {
      carerId: carerId ?? 0,
      startDate: startDate,
      endDate: endDate,
      status: status === RotaOptions.open ? "ACTIVE" : status,
      agencyId: agencyId ?? 0,
      branchId: branchId ?? 0,
      gradeId: gradeId ?? 0,
      shiftType: shiftType?.value === "ANY" ? "" : shiftType?.value || null,
    };
    showClientEstimatehrsAPI(params, (data, error) => {
      if (error === null) {
        setClientdata(data);
      }
    });
  }
  function showcarerEstimatehoursList() {
    if (!clientId) return;
    let params = {
      clientId: clientId ?? 0,
      startDate: startDate,
      endDate: endDate,
      status: status === RotaOptions.open ? "ACTIVE" : status,
      agencyId: agencyId ?? 0,
      branchId: branchId ?? 0,
      gradeId: gradeId ?? 0,
      shiftType: shiftType?.value === "ANY" ? "" : shiftType?.value || null,
    };
    showCarerEstimatehrsAPI(params, (data, error) => {
      if (error === null) {
        setClientdata(data);
      }
    });
  }
  useEffect(() => {
    showcarerEstimatehoursList();
  }, [clientId, startDate, endDate, status, agencyId, branchId, gradeId, shiftType]);
  useEffect(() => {
    showclientEstimatehoursList();
  }, [carerId, startDate, endDate, status, agencyId, branchId, gradeId, shiftType]);

  return (
    <>
      <div className="rota-matrix-div">
        <RotaMatrix
          hList={datesBetween}
          vList={rotaList}
          rotaType={type}
          isSwitchOn={isSwitchOn}
          clientdata={clientdata}
          totalRotaHours={totalRotaHours}
          onCancel={() => {
            fetchData();
          }}
        />
      </div>
      <LoadingComponent isLoading={loading} />
    </>
  );
};

export default RotaList;
